<div class="mx-5 d-flex flex-column justify-content-start align-items-stretch" style="height: 100%;">
    <div class="align-self-start d-flex flex-row align-items-center justify-content-start">
        <button type="button" class="btn btn-sm btn-primary " btnDebounceClick [disabled]="relancableSuppliers.length==0"
                (debounceClick)="btnRelancerClick()" paflabel="Relancer_la_Demande_de_Referencement"></button>
        <label *ngIf="relancableSuppliers.length>0" class="ml-1">{{relancableSuppliers.length}} fournisseur{{relancableSuppliers.length>1?'s':''}} relançable{{relancableSuppliers.length>1?'s':''}}</label>
    </div>
    <small class="font-italic" paflabel="Relancer_la_Demande_de_Referencement_commentaire"></small>
    <div class="card mt-3 shadow-sm flex-fill">
        <div class="card-body" ID="encoursListContainer">
            <kendo-grid id="lst-encours-grid" #grid [data]="gridData" [pageSize]="state.take" [skip]="state.skip" class="takapa-grid-results no-ellipsis"
                [sort]="state.sort" [filter]="state.filter" [sortable]="true" [pageable]="gridPageableSettings"
                [selectable]="{checkboxOnly:true,mode: 'multiple'}"  kendoGridSelectBy="Id" (selectionChange)="gridSelectionChange($event)"
                [selectedKeys]="selectedSuppliersIds"
                [filterable]="'menu'" (dblclick)="dblClickGridEvent()" (cellClick)="selectRow($event)" [height]="600"
                 (filterChange)="filterChange($event)" (dataStateChange)="dataStateChange($event)">
                <kendo-grid-messages filterIsFalse="Non&nbsp;&nbsp;" filterIsTrue="Oui&nbsp;&nbsp;">
                </kendo-grid-messages>
                <kendo-grid-checkbox-column [showSelectAll]="true" [width]="20"></kendo-grid-checkbox-column>
                <kendo-grid-column field="Id" [width]="20"  [filterable]="false" title="" >
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <history-button [supplierId]="dataItem.Id"></history-button>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="StatutId" [width]="170"  title="Statut" class="text-center">
                    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
                        let-filterService="filterService">
                        <div style="width:100%;">
                            <kendo-multiselect class="filter-multi-select form-control" name="filterStatuts"
                                [data]="lstStatuts" textField="traduction" valueField="Id" [valuePrimitive]="true"
                                [value]="state.filter | filterValues"
                                (valueChange)="gridFiltersChange($event, filterService,column)">
                                <ng-template kendoMultiSelectTagTemplate let-dataItem>
                                    <supplier-statut-badge [supplierStatutId]="dataItem.Id">
                                    </supplier-statut-badge>
                                </ng-template>
                                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                    <supplier-statut-badge [supplierStatutId]="dataItem.Id">
                                    </supplier-statut-badge>
                                </ng-template>
                            </kendo-multiselect>
                        </div>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <supplier-statut-badge [supplierStatutId]="dataItem.StatutId"></supplier-statut-badge>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="SupplierName" [width]="250" title="Nom du fournisseur">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <a class="control-label" [routerLink]="getSupplierLink(dataItem)" [paftooltip]="'Fiche_fournisseur'" target="_blank">
                            {{ dataItem.SupplierName }}
                        </a>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column  [width]="120" [format]="{ date: 'short' }" field="DateCreation"
                    title="Date de demande" filter="date">
                </kendo-grid-column>
                
                <kendo-grid-column  [width]="150" field="Demandeur" title="Demandeur" class="text-center">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="text-center" class="cell-vert badge">{{dataItem.Demandeur}}</div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column  [width]="120" field="AchOpeVal" title="Acheteur Op." class="text-center">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="badge" [ngClass]="cellClass(dataItem.AchOpeColor)">{{dataItem.AchOpeVal}}</div>
                    </ng-template>
                </kendo-grid-column>
                <!-- <kendo-grid-column  [width]="120" field="AchFamVal" title="Acheteur Fam." class="text-center">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div [innerHTML]="getAchFamCellDisplay(dataItem)"></div>
                    </ng-template>
                </kendo-grid-column> -->
                <kendo-grid-column  [width]="120" field="QualiteVal" title="Ctrl. qualité" class="text-center">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="badge" [ngClass]="cellClass(dataItem.QualiteColor)">{{dataItem.QualiteVal}}</div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column  [width]="120" field="ComptaVal" title="Comptable" class="text-center">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="badge" [ngClass]="cellClass(dataItem.ComptaColor)">{{dataItem.ComptaVal}}</div>
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid>
        </div>
    </div>
</div>
